/*
 * Turbo Drive fires turbo:load on full visits, but failed form submissions
 * (e.g. 422) only re-render via turbo:render. Run page setup on load always,
 * and on render only when the fetch did not succeed — so successful visits
 * do not double-initialize plugins (Foundation, Slick, Select2, React).
 */
export const onTurboPageUpdate = callback => {
  let runOnNextRender = false

  document.addEventListener('turbo:before-fetch-response', event => {
    const { fetchResponse } = event.detail

    runOnNextRender = Boolean(fetchResponse) && !fetchResponse.succeeded
  })

  document.addEventListener('turbo:render', () => {
    if (!runOnNextRender) {
      return
    }

    runOnNextRender = false
    callback()
  })

  document.addEventListener('turbo:load', callback)
}
